<template>
    <Row v-if="isLoadingPage" type="none" class="bg-white rounded shadow">

        <Modal
            :text="modalText"
            id="modal_show"
            :on-ok-pressed="() => $i18nHelper.toUrl('login')"
        />

        <FormTag v-if="!isExpiredToken" class="container pt-4">
            <Row type="form-row">
                <InputBox
                    class="text-gray-500 font-bold"
                    model-name="newPassword"
                    title="user.newPassword"
                    type="password"
                    sm-size="6"
                    check-to-model="modelStrongPassword"
                    :model-form="modelForm"
                    :errors="errors"
                    :model-state="modelNotEmptyState"
                />
            </Row>

            <Row type="form-row">
                <InputBox
                    class="text-gray-500 font-bold pt-4"
                    model-name="repeatPassword"
                    title="user.repeatPassword"
                    type="password"
                    sm-size="6"
                    check-to-model="modelStrongPassword"
                    :model-form="modelForm"
                    :errors="errors"
                    :model-state="modelNotEmptyState"
                />
            </Row>

            <MarginTop/>

            <SubmitRow class="py-4" :is-loading="isLoading" :is-disabled="!isSameWithConfirmedPassword || hasErrors" :do-action="send" text="user.resetPassword"/>
        </FormTag>
        <div v-if="isExpiredToken">
            {{ $t('user.resetTokenExpired') }}
            <router-link :to="$i18nHelper.getUrl('forgot-password')">{{ $t('user.tryAgain') }}</router-link>
        </div>
    </Row>
</template>

<script>
import loginMixin from "../mixin/loginMixin";
import FormTag from "../components/html/FormTag";
import Row from "../components/html/Row";
import InputBox from "../components/InputBox";
import validatorMixin from "../mixin/validatorMixin";
import SubmitRow from "../components/SubmitRow";
import MarginTop from "../components/html/MarginTop";
import Modal from "../components/html/Modal";
import {mapActions} from "vuex";

export default {
    components: {Modal, MarginTop, SubmitRow, InputBox, Row, FormTag},
    mixins: [loginMixin, validatorMixin],
    computed: {
        isSameWithConfirmedPassword() {
            return this.modelForm.newPassword === this.modelForm.repeatPassword
        }
    },
    data() {
        return {
            isLoadingPage: false,
            modalText: '',
            isExpiredToken: false,
            errors: {
                newPassword: null,
                repeatPassword: null
            },
            modelForm: {
                newPassword: '',
                repeatPassword: ''
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'user.resetPassword'},
            ],
            isLoading: false,
        }
    },
    methods: {
        ...mapActions(['fetchResetPassword', 'fetchCheckResetToken']),
        send() {
                this.isLoading = true;
                this.fetchResetPassword({
                    newPassword: this.modelForm.repeatPassword,
                    resetToken: this.$route.params.token
                })
                    .then((response) => {
                        this.isLoading = false;

                        if (response === 'Successfully changed') {
                            this.modalText = 'user.passwordChanged'

                        } else {
                            this.modalText = response
                        }

                        this.$bvModal.show('modal_show');
                        this.isExpiredToken = true;
                    })
                    .catch((error) => {
                        this.modalText = error
                        this.$bvModal.show('modal_show');

                        this.isLoading = false;
                    })
        }
    },
    mounted() {
        this.$root.showOverlay = true
        this.fetchCheckResetToken({accessToken: this.$route.params.token, refreshToken: ''})
            .then((response) => {
                if (!response.isAvailable) {
                    this.isExpiredToken = true
                }

                this.isLoadingPage = true
            })
            .finally(() => {
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>

</style>
